import { PureComponent, ReactNode } from 'react';
import PadV2PxElementCard from '../rightPanel/workspace/padV2/PadV2PxElementCard';
import onContainerClick from '../../../pages/prescriptionPad/onClickContainer';
import { ProcedureIcon } from '../../common/Icons';
import { ProcedureOnPadAutoSuggest } from './ProcedureAutoSuggest';
import PadV2ProcedureTable from './ProcedureTable';
import TemplateIcons from '../rightPanel/workspace/padV2/TemplateIcons';

class Procedures extends PureComponent {
    ProceduresIcon = ProcedureIcon();

    render(): ReactNode {
        return (
            <div onFocus={onContainerClick}>
                <PadV2PxElementCard
                    icon={this.ProceduresIcon}
                    headingText={'Procedures'}
                    iconContainerBgClassName="bg-neutral-2"
                    bodyCssClassName="space-y-8 rounded-8"
                    renderHeaderRight={() => (
                        <div className="flex mt-8 mr-16">
                            <div className="flex items-center space-x-16 ml-16">
                                <TemplateIcons
                                    pxToolKey={'procedures'}
                                    isModal={false}
                                    withPeak={true}
                                />
                            </div>
                        </div>
                    )}
                >
                    <PadV2ProcedureTable />
                    <ProcedureOnPadAutoSuggest />
                </PadV2PxElementCard>
            </div>
        );
    }
}

export default Procedures;
